<template>
    <Card :title="$route.meta.title" dis-hover>
        <Form inline @keydown.enter.native.prevent="refreshGetTableData">
            <FormItem>
                <!--<span slot="label" style="line-height:14px;">状态：</span>-->
                <RadioGroup v-model="query.status" @on-change="getTableData" type="button">
                    <Radio :label="null">全部</Radio>
                    <Radio :label="0">新申请</Radio>
                    <Radio :label="1">检测中</Radio>
                    <Radio :label="2">已完成</Radio>
                    <Radio :label="3">已取消</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem>
                <!--<span slot="label" style="line-height:14px;">是否合格：</span>-->
                <RadioGroup v-model="query.qualified" @on-change="getTableData">
                    <Radio :label="null">全部</Radio>
                    <Radio :label="0">不合格</Radio>
                    <Radio :label="1">合格</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem>
                <tester-sel v-model="query.tester.id" :withoutDepart="true"></tester-sel>
            </FormItem>
            <FormItem>
                <Button type="primary" icon="ios-search" @click="refreshGetTableData">查询</Button>
            </FormItem>
        </Form>

        <Table :loading="tableLoading" :columns="tableColumns" :data="tableList">
            <template slot-scope="{row}" slot="examMethod">
                {{ ['自由加速法', '自由加载法'][row.examMethod] }}
            </template>
            <template slot-scope="{row}" slot="testerName">
                {{ row.tester.name }}
            </template>
            <template slot-scope="{row}" slot="status">
                {{ row.statusName }}
            </template>
            <template slot-scope="{row}" slot="qualified">
                {{ row.qualifiedName }}
            </template>

            <template slot-scope="{row}" slot="operation">
                <a class="opt-txt" @click="handleOperation(row, 'DETAIL')">详情</a>
                <a v-if="row.status < 2" class="opt-txt" @click="handleOperation(row, 'CANCEL')">取消</a>
            </template>
        </Table>
        <page-model :paging="page" :total="total" @page-change="handlePageChange"></page-model>

        <exam-data v-model="modalVisible" :apply-id="applyId" @on-success="getTableData"></exam-data>
    </Card>
</template>
<script>
import iExam from '@/module/main/api/iExam';
import tableHelper from '@/mixins/tableHelper';
import _don from '@/libs/doson'
import examData from "../../components/examData";
import TesterSel from "../../components/TesterSel";

export default {
    name: "exam_apply_mng",
    mixins: [tableHelper],
    components: {
        examData, TesterSel
    },
    data() {
        return {
            query: {
                status: null,
                qualified: null,
                tester: { id: null }
            },
            tableColumns: [
                { title: '序号', key: 'idx', width: 80 },
                { title: '检测编号', key: 'processNo' },
                { title: '环保登记号码', slot: 'epNo', minWidth: 100 },
                { title: '检测方式', slot: 'examMethod' },
                { title: '检测人', slot: 'testerName' },
                { title: '烟度值', key: 'smokeVal' },
                { title: '转速', key: 'realSpeed' },
                { title: '状态', slot: 'status' },
                { title: '是否合格', slot: 'qualified' },
                { title: '申请时间', key: 'addTime' },
                { title: '操作', slot: 'operation', width: 160 }
            ],
            modalVisible: false,
            applyId: 0
        }
    },
    mounted() {
        this.getTableData()
    },
    methods: {
        getTableData() {
            iExam.applytList(this.page, this.query).then(res => {
                var i = 1
                this.tableList = res.content.map(e => {
                    e.idx = (this.page.page - 1) * this.page.size + i++
                    if (e.status == 3) {
                        e.statusName = '已取消'
                        e.qualifiedName = '已取消'
                    } else if (e.status == 2) {
                        e.statusName = '已完成'
                        e.qualifiedName = e.qualified ? '合格' : '不合格'
                    } else {
                        e.statusName = ['新检测', '检测中'][e.status]
                        e.qualifiedName = '-'
                    }
                    return e;
                });
                this.total = res.totalElements
            }).loadingSwitch(this, 'tableLoading');
        },
        async handleOperation(row, type) {
            if (type === 'DETAIL') {
                this.applyId = row.id
                this.modalVisible = true
                return;
            }
            if (type === 'CANCEL') {
                this.$Modal.confirm({
                    title: '提示',
                    content: `是否取消该检测，确认继续？`,
                    onOk: () => {
                        iExam.applytCancel(row.id).then(() => {
                            this.$Message.success('操作成功');
                            this.getTableData();
                        }).loadingSwitch(this, 'tableLoading');
                    }
                });
                return;
            }
        },
    },
}
</script>

<style scoped lang="less">
</style>
